// 會員路由
const name = '商家'
import Layout from '@/view/layout' // 主框架

export default {
  path: '/merchant/sellers',
  component: Layout,
  children: [
    {
      path: 'marketingdistributor',
      name: `店鋪列表`,
      component: () => import('@/view/mall/marketing/distributor'),
      children: [
        {
          path: 'editor/:itemId?',
          component: () => import('@/view/merchant/store')
        },
        {
          path: 'template/:distributor_id?',
          component: () => import('@/view/mall/marketing/distributor_template')
        },
        {
          path: 'details/:id?',
          component: () => import('@/view/mall/marketing/distributor_details')
        },
        {
          path: 'wxpaysetting',
          component: () => import('@/view/mall/marketing/distributor_wxpaysetting')
        },
        {
          path: 'alipaysetting',
          component: () => import('@/view/mall/marketing/distributor_alipaysetting')
        }
      ]
    },
    {
      path: 'merchantinfo',
      name: `商家列表`,
      component: () => import('@/view/mall/marketing/merchantList/editor.vue')
    },
    {
      path: 'distributoraftersalesaddress',
      name: `售後地址`,
      component: () => import('@/view/mall/marketing/distributorAftersalesAddress')
    }
  ]
}
